import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import InputText from "commons/ui/input/InputText";

import TwoLanguagesAdornment from "components/subComponents/TwoLanguagesAdornment";
import TitleFunctionsTopBlock from "components/ui/TitleFunctionsTopBlock";

import useCheckSectionErrors from "hooks/form/blocks/useCheckSectionErrors";
import useSectionOneTitleTexts from "hooks/form/blocks/useSectionOneTitleFiveTexts";
import useTitleFunctionsTopBlock from "hooks/useTitleFunctionsTopBlock";

function SectionOneTitleTextsForm() {
    const { buttonDelete, formHook } = useSectionOneTitleTexts();

    useCheckSectionErrors({ formHook });

    const { checkErrorVisibility, setValue, form } = formHook;

    const titleFunctionsTopBlockHook = useTitleFunctionsTopBlock({
        buttonDelete: buttonDelete,
    });

    return (
        <>
            <TitleFunctionsTopBlock titleFunctionsTopBlockHook={titleFunctionsTopBlockHook} />

            {titleFunctionsTopBlockHook.closedBlock && (
                <>
                    <GridColumn>
                        <GridRow>
                            <GridItem>
                                <span>Inserisci i testi per tutte le lingue</span>
                            </GridItem>
                        </GridRow>
                    </GridColumn>

                    <GridColumn>
                        <GridRow>
                            <div className={"col-xs-24-12"}>
                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Titolo"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.title}
                                            setValue={setValue}
                                            path={"text.it.title"}
                                            checkErrorVisibility={checkErrorVisibility}
                                            autoFocus
                                        />
                                    </GridItem>
                                </GridRow>
                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Sottotitolo"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.subtitle}
                                            setValue={setValue}
                                            path={"text.it.subtitle"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Testo nel bottone"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.button_label}
                                            setValue={setValue}
                                            path={"text.it.button_label"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>
                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Url del bottone"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.button_url}
                                            setValue={setValue}
                                            path={"text.it.button_url"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Testo"}
                                            startAdornment={TwoLanguagesAdornment("it")}
                                            value={form.text.it.text}
                                            setValue={setValue}
                                            path={"text.it.text"}
                                            checkErrorVisibility={checkErrorVisibility}
                                            textarea
                                            largeBox
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>

                            <div className={"col-xs-24-12"}>
                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Titolo"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.title}
                                            setValue={setValue}
                                            path={"text.en.title"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Sottotitolo"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.subtitle}
                                            setValue={setValue}
                                            path={"text.en.subtitle"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Testo nel bottone"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.button_label}
                                            setValue={setValue}
                                            path={"text.en.button_label"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Url del bottone"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.button_url}
                                            setValue={setValue}
                                            path={"text.en.button_url"}
                                            checkErrorVisibility={checkErrorVisibility}
                                        />
                                    </GridItem>
                                </GridRow>

                                <GridRow>
                                    <GridItem className={"col-xs-12-12"}>
                                        <InputText
                                            label={"Testo"}
                                            startAdornment={TwoLanguagesAdornment("en")}
                                            value={form.text.en.text}
                                            setValue={setValue}
                                            path={"text.en.text"}
                                            checkErrorVisibility={checkErrorVisibility}
                                            textarea
                                            largeBox
                                        />
                                    </GridItem>
                                </GridRow>
                            </div>
                        </GridRow>
                    </GridColumn>
                </>
            )}
        </>
    );
}

export default SectionOneTitleTextsForm;
